// Mobile persists the React Query cache to localStorage so the app opens
// offline. That cache holds tenant data, so it must not outlive a logout or be
// restored for a different user.
export const PERSISTED_QUERY_CACHE_KEY = "ardley-crm.query-cache";

// The persister's default key, used before the cache had its own. Devices that
// ran the older build still hold a copy that no logout ever cleared.
const LEGACY_PERSISTED_QUERY_CACHE_KEY = "REACT_QUERY_OFFLINE_CACHE";

export function clearLegacyPersistedQueryCache() {
  window.localStorage.removeItem(LEGACY_PERSISTED_QUERY_CACHE_KEY);
}

export function clearPersistedQueryCache() {
  window.localStorage.removeItem(PERSISTED_QUERY_CACHE_KEY);
  clearLegacyPersistedQueryCache();
}
